import {
  notifyError,
  useNotifications,
  notifySuccess,
} from 'Logic/Notifications.js'
import { useMutation } from 'Data/Api.js'
import { useDataSubmit } from 'Simple/Data.js'

import mutation from './mutation-uninstall.graphql.js'

export default function useDataOnActionUninstall(props, data, reExecuteQuery) {
  let [, executeMutation] = useMutation(mutation)

  let [, notify] = useNotifications()

  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  return async function onAction({ value, args, change }) {
    if (process.env.REACT_APP_ENV === 'production') return

    let mutationResponse = await executeMutation({
      app_id: value.id,
    })

    if (mutationResponse.error || !mutationResponse.data.apps_uninstall.ok) {
      return notify(notifyError('Failed to uninstall app.'))
    }

    notify(notifySuccess('App uninstalled!'))

    submit({ type: 'back/apps' })
  }
}
